// Guidelines
// Sentences always end with a "."
// Dont use "..." at any point
// singular = "was" Plural(more than one instance) = "were"
// Add the action after "successfully", i.g "was/were successfully created."

export const submitted = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully submitted.`;

export const saved = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully saved.`;

export const created = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully created.`;

export const updated = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully updated.`;

export const changed = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully changed.`;

export const deleted = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully deleted.`;

export const removed = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully removed.`;

export const revoked = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully revoked.`;

export const cancelled = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully cancelled.`;

export const stopped = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully stopped.`;

export const paused = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully paused.`;

export const resumed = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully resumed.`;

export const generated = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully generated.`;

export const reverted = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully reverted.`;

export const activated = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully activated.`;

export const deactivated = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully deactivated.`;

export const closed = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully closed.`;

export const reopened = (name: string, plural: boolean = false) => `Your ${name} ${plural ? 'were' : 'was'} successfully reopened.`;
